import React, {HTMLInputTypeAttribute} from "react";


import {
    Row, Col,
    ColProps,
} from "react-bootstrap";


import {
    FormFieldStatusComponent, FormFieldStatusInterface
} from "@Elements";


interface InputFieldComponentProps extends ColProps {
    inputFieldType?: HTMLInputTypeAttribute;
    inputFieldLabel?: string;
    inputFieldPlaceholder?: string;
    inputFieldValue: string;
    inputFieldValueHandler: (e:React.ChangeEvent<HTMLInputElement>) => void;
    inputFieldRequiredStatus?: boolean;
    inputFieldStatus?: FormFieldStatusInterface | null;
}


export const InputFieldComponent:React.FC<InputFieldComponentProps> = ({
    inputFieldType = 'text',
    inputFieldLabel, inputFieldPlaceholder,
    inputFieldValue, inputFieldValueHandler,
    inputFieldRequiredStatus,
    inputFieldStatus,
    xs = 12, sm, lg, xl
}) => {


    return (
        <Col xs={xs} sm={sm} lg={lg} xl={xl} className={'input-field-component'}>
            <Row className={'input-field-component__field-content'}>

                {inputFieldLabel &&
                <Col xs={12} className={'input-field-component__field-label'}>
                    <span className={'input-field-component__field-label__label-text'}>{inputFieldLabel}</span>
                    {inputFieldRequiredStatus && <span className={'input-field-component__field-label__label-required-status'}>*</span>}
                </Col>
                }

                <Col xs={12} className={'input-field-component__field-input'}>
                    <input
                        type={inputFieldType}
                        value={inputFieldValue} placeholder={inputFieldPlaceholder}
                        onChange={inputFieldValueHandler}
                    />
                </Col>

                {inputFieldStatus &&
                <FormFieldStatusComponent formFieldStatus={inputFieldStatus} />
                }

            </Row>
        </Col>
    )

};


export default InputFieldComponent;
